export default __webpack_public_path__ + "static/media/maneva.4656f2e5.mp3";